import React from "react";
import {Row, Col, FormControl, FormGroup, ControlLabel, Form} from 'react-bootstrap';
import JoinPickupSiteFilter from "./JoinPickupSiteFilter.js";
import {PickupSiteSelectionTypes} from "../../common/constants";
import {translate} from '../../i18n/translate.js';

const waitListLabel = (isWaitList, waitListCustomLabel) => {
    if(isWaitList) {
        return (<div className="pick-up-site-waitList-comment">{waitListCustomLabel || translate("waitlist only")}</div>);
    }
};

class JoinPickupSiteList extends React.Component {
    componentDidMount() {
        for (let ref in this.refs) {
            if (this.refs.hasOwnProperty(ref)) {
                const elem = this.refs[ref];
                if (elem.className == "list-row-comment")
                    if (elem.scrollHeight > 42) {
                        ref = ref.replace("comment_", "more_");
                        this.refs[ref].style.display = "block"
                    }
            }
        }
    }

    expendComment = (e) => {
        let id = e.target.id;
        this.refs[id].style.display = "none";
        id = id.replace("more_", "comment_");
        this.refs[id].style.maxHeight = "initial";
    };

    pickupSiteSelected = (pickupSite, isWaitList) => {
        if(this.props.isValidPickupSiteSelection(pickupSite)) {
            this.props.setPickupSite(pickupSite, isWaitList);
        }
    };

    getComment = (pickupSite, isWaitList) => {
        if (this.props.clientViewPort.isXs) {
            return (<Col className="pick-up-site-comment-container" name="pickupSiteComments" xs={11}>
                <div className="list-row-comment" id={"comment_" + pickupSite.key}
                     ref={"comment_" + pickupSite.key}
                     dangerouslySetInnerHTML={{__html: pickupSite.comment}}/>
            </Col>);
        } else {
            return (<Col className="pick-up-site-comment-container" name="pickupSiteComments" sm={5}>
                {waitListLabel(isWaitList, this.props.joinWaitListLocationLabel)}
                <div className="comment" dangerouslySetInnerHTML={{__html: pickupSite.comment}}/>
            </Col>);
        }
    };

    createPickupSiteLine = (pickupSite, isWaitList) => {
        const styleClass = "list-row pickup-site-row" + (pickupSite.isNonSelectable ? " list-row-not-selectable" : "");
        const selectedWaitListSite = pickupSite.key === this.props.pickupSiteWaitListKey;
        const selectedSite = pickupSite.key === this.props.pickupSiteKey;
        return (<Row name="pickupSiteRow" className={styleClass} key={pickupSite.key}>
            <Row onClick={this.pickupSiteSelected.bind(this, pickupSite, isWaitList)} className="pickup-site-row-click-container">
                <Col className="pick-up-site-title-radio" sm={5} xs={11}>
                    <div className="list-item-title">
                        {
                            isWaitList ?
                                <input type="radio" className="radio-select" name="waitListSite"
                                       checked={selectedWaitListSite}
                                       value={pickupSite.key}
                                       onChange={this.pickupSiteSelected.bind(this, pickupSite, isWaitList)}
                                />
                                :
                                <input type="radio" className="radio-select" name="pickupSite" checked={selectedSite}
                                       value={pickupSite.key}
                                       onChange={this.pickupSiteSelected.bind(this, pickupSite, isWaitList)}
                                />
                        }
                        <div className="item-title pickup-site-title" name="pickupSiteTitle">{pickupSite.title}</div>
                        <div className="pickup-site-address" name="pickupSiteAddress">{pickupSite.shortAddress}</div>
                    </div>
                </Col>
                <Col className="pick-up-site-delivery-day" sm={2} xs={12} name="pickupSiteDeliveryDay">
                    <div className="delivery-day">{translate(pickupSite.deliveryDays)}</div>
                    <div className="delivery-hours">{pickupSite.deliveryHours}</div>
                    {this.props.clientViewPort.isXs ? waitListLabel(isWaitList, this.props.joinWaitListLocationLabel) : undefined}
                </Col>
                {this.getComment(pickupSite, isWaitList)}
            </Row>
            {this.props.clientViewPort.isXs ?
                <Col className="pick-up-site-comment-container" name="pickupSiteCommentsMore" xs={11}>
                    <div className="read-more-comment" id={"more_" + pickupSite.key} ref={"more_" + pickupSite.key}
                         onClick={this.expendComment}>{translate("More") + "..."}
                    </div>
                </Col>:undefined
            }
        </Row>);
    };

    render() {
        const pickupSites = this.props.availablePickupSites;
        if (pickupSites) {
            let sites = [];
            let waitListSites = [];
            pickupSites.forEach(function (pickupSite) {
                if (pickupSite.isAvailable) {
                    sites.push(this.createPickupSiteLine(pickupSite, false));
                } else if (!pickupSite.isAvailable && pickupSite.isWaitListAllowed) {
                    waitListSites.push(this.createPickupSiteLine(pickupSite, true));
                }
            }.bind(this));
            return (<div id="pickupSiteListContainer" className="table-container-selector">
                <Form horizontal className="list-container">
                    <JoinPickupSiteFilter clientViewPort={this.props.clientViewPort}
                                          deliveryDayFilter={this.props.deliveryDayFilter}
                                          setDeliveryDayFilter={this.props.setDeliveryDayFilter}
                                          pickupSiteSelectionType={PickupSiteSelectionTypes.LIST}
                                          pickupSites={this.props.pickupSites}/>
                    {
                        this.props.clientViewPort.isXs ? undefined :
                            <FormGroup className="columns-title" controlId="pickupSiteTitles">
                                <Col componentClass={ControlLabel} className="title-column" sm={5}>{translate("Available Location")}</Col>
                                <Col componentClass={ControlLabel} className="title-column" md={2} sm={2}>{this.props.overrideSignupDaysColumnLabel ? "Pick-up" : translate("Delivery Day")}</Col>
                                <Col componentClass={ControlLabel} className="title-column" md={5} sm={5}>{translate("Comments")}</Col>
                            </FormGroup>
                    }
                    {sites}
                </Form>
                {
                    waitListSites.length > 0 ?
                        (<Form horizontal className="list-container">
                            {
                                !this.props.clientViewPort.isXs ?
                                    <FormGroup className="columns-title" controlId="pickupSiteWaitListTitles">
                                        <Col componentClass={ControlLabel} className="title-column" sm={5}>{translate("Waitlist Location")} </Col>
                                        <Col componentClass={ControlLabel} className="title-column" md={2} sm={2}>{translate("Delivery Day")}</Col>
                                        <Col componentClass={ControlLabel} className="title-column" md={5} sm={5}>{translate("Comments")}</Col>
                                    </FormGroup> :
                                    <Row className="waitlist-title-header">
                                        <label className="waitlist-title">{translate("Waitlist Locations")}</label>
                                    </Row>
                            }
                            {waitListSites}
                        </Form>) : undefined
                }
            </div>);
        }
        return false;
    }
}

export default JoinPickupSiteList;


// WEBPACK FOOTER //
// ./src/components/join/JoinPickupSiteList.js